import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutAlignLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM9 7H7L7 17H9L9 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignLeft;
